import { IBoundingBox } from '@app-types/geo';

// [minX, minY, maxX, maxY]
export const turfBoundsToBoundingBox = (
  bounds: [number, number, number, number] | [number, number, number, number, number, number],
): IBoundingBox => ({
  southWest: { latitude: bounds[1], longitude: bounds[0] },
  northEast: { latitude: bounds[3], longitude: bounds[2] },
});
